import { render, staticRenderFns } from "./MyStaffReviewDetails.vue?vue&type=template&id=6f166ca3&scoped=true"
import script from "./MyStaffReviewDetails.vue?vue&type=script&lang=js"
export * from "./MyStaffReviewDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f166ca3",
  null
  
)

export default component.exports